import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Floating "back to top" button.
 * Sits just above the AI assistant button (bottom-right stack).
 * Appears after 600 px of scroll — smooth-scrolls to the top on click.
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Natrag na vrh"
      title="Natrag na vrh"
      data-testid="back-to-top-btn"
      className="fixed right-4 md:right-6 bottom-24 md:bottom-28 z-40 w-11 h-11 rounded-full bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 shadow-lg text-gray-700 dark:text-gray-200 hover:text-red-600 hover:border-red-400 transition-colors flex items-center justify-center"
    >
      <ArrowUp size={18} />
    </button>
  );
}
